import { useObjectConfigStore } from '@/stores/objectConfig';
import { useListConfigStore } from '@/stores/listConfig';
import { useSavedViewsStore } from '@/stores/savedViews';
import { useGridPreferencesStore } from '@/stores/gridPreferences';
import { clearQualifiers } from '@/composables/useQualifiers';

/**
 * Forget everything read for one organization, as another one is entered.
 *
 * Switching organization from the menu is a router navigation, not a reload, so
 * whatever the lists cached stays in memory. Only the object layouts used to be
 * dropped: the next organization's Contacts list then opened with the previous
 * one's columns, saved views, grid preferences and filters — custom fields
 * included — until someone reloaded the page.
 *
 * A cache that holds organization data and is not listed here leaks the same
 * way: add it.
 */
export function resetOrgScopedCaches() {
    useObjectConfigStore().invalidateAll();
    useListConfigStore().invalidateAll();
    useSavedViewsStore().reset();
    useGridPreferencesStore().reset();
    clearQualifiers();
}
